import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-document-list-tkt.actions';
import { GetDocumentListTktState } from './get-document-list-tkt.state';

/**
 * getDocumentListTkt initial state
 */
export const getDocumentListTktInitialState: GetDocumentListTktState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetDocumentListTkt Store
 */
export const getDocumentListTktReducerFeatures: ReducerTypes<GetDocumentListTktState, ActionCreator[]>[] = [
  on(actions.setGetDocumentListTkt, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetDocumentListTkt, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetDocumentListTkt, () => getDocumentListTktInitialState),

  on(actions.cancelGetDocumentListTktRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetDocumentListTkt, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetDocumentListTktFromApi, actions.updateGetDocumentListTktFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetDocumentListTkt Store reducer
 */
export const getDocumentListTktReducer = createReducer(
  getDocumentListTktInitialState,
  ...getDocumentListTktReducerFeatures
);
